module.exports = __webpack_public_path__ + "img/20190917173109360截图20190917161001082.03889ee6.jpg";